import Vue from 'vue/dist/vue.esm'

Vue.component(
  'modal-quick-view-vue',
  () => import(/* webpackChunkName: "[request]" */ 'components/ModalQuickView')
)
